module.exports = __webpack_public_path__ + "img/95.5a1eaf96.jpg";